import { render, staticRenderFns } from "./MotorcycleLearningDetail.vue?vue&type=template&id=46c0a4b2&scoped=true&"
import script from "./MotorcycleLearningDetail.vue?vue&type=script&lang=js&"
export * from "./MotorcycleLearningDetail.vue?vue&type=script&lang=js&"
import style0 from "./MotorcycleLearningDetail.vue?vue&type=style&index=0&id=46c0a4b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c0a4b2",
  null
  
)

export default component.exports